import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import SectionTitle from '../shared/SectionTitle';
import InfoCard from '../shared/InfoCard';
import { t } from '../../../../utils/textUtils';
import { getDisplayName, getSiteEngineerNames } from '../utils/formatters';
import { DETAIL_GRID_SX } from '../utils/constants';

const TeamTab = ({ project, canEdit, onManageEngineers }) => {
  const siteEngineerNames = getSiteEngineerNames(project);

  return (
    <>
      <SectionTitle
        title={t('TIM PROYEK')}
        subtitle={t('Daftar pihak yang terlibat dalam proyek ini.')}
        actions={
          canEdit ? (
            <Button
              variant="outlined"
              size="small"
              onClick={onManageEngineers}
              sx={{
                borderColor: '#2563EB',
                color: '#2563EB',
                '&:hover': { borderColor: '#1D4ED8', backgroundColor: '#EFF6FF' },
                fontWeight: 600
              }}
            >
              {t('KELOLA INSINYUR LAPANGAN')}
            </Button>
          ) : null
        }
      />

      <Box sx={DETAIL_GRID_SX}>
        <InfoCard
          label={t('PEMILIK PROYEK')}
          value={
            project.projectClient
              ? getDisplayName(project.projectClient, t('TIDAK DITENTUKAN'))
              : project.pemilikProyek || t('TIDAK DITENTUKAN')
          }
          icon={<PersonIcon sx={{ color: '#6366F1' }} />}
        />
        <InfoCard
          label={t('MANAJER PROYEK')}
          value={getDisplayName(project.manager, t('BELUM DITUGASKAN'))}
          icon={<PersonIcon sx={{ color: '#0EA5E9' }} />}
        />
        <InfoCard
          label={t('KOORDINATOR PRODUKSI')}
          value={getDisplayName(project.productionCoordinator, t('BELUM DITUGASKAN'))}
          icon={<PersonIcon sx={{ color: '#F59E0B' }} />}
        />
        <InfoCard
          label={t('MANAJER LAPANGAN')}
          value={getDisplayName(project.siteManager, t('BELUM DITUGASKAN'))}
          icon={<PersonIcon sx={{ color: '#22C55E' }} />}
        />
        <InfoCard label={t('INSINYUR LAPANGAN')} icon={<PersonIcon sx={{ color: '#0f172a' }} />}>
          {siteEngineerNames.length > 0 ? (
            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
              {siteEngineerNames.map((name) => (
                <Chip key={name} label={name} size="small" variant="outlined" />
              ))}
            </Stack>
          ) : (
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {t('BELUM DITUGASKAN')}
            </Typography>
          )}
        </InfoCard>
      </Box>
    </>
  );
};

export default TeamTab;
